// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__ztemI","errorLogs":"styles_errorLogs__F-xFS"};